export enum FirstOrSubsequentRealEstate {
  FIRST = 'FIRST',
  SUBSEQUENT = 'SUBSEQUENT',
}
